import { render, staticRenderFns } from "./DashboardDemographics.vue?vue&type=template&id=7cf7ef5a&"
import script from "./DashboardDemographics.vue?vue&type=script&lang=js&"
export * from "./DashboardDemographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports